import { render, staticRenderFns } from "./GetCompany.vue?vue&type=template&id=f1a7a37a&"
import script from "./GetCompany.vue?vue&type=script&lang=js&"
export * from "./GetCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports